import { OperatingHours, WeeklyHours } from '@leverege/operating-hours';
import OperatingHoursEditor from "./OperatingHoursEditor.js";
import WeeklyHoursEditor from "./WeeklyHoursEditor.js";
export default {
  install(plg) {
    plg.addPlugin('ModelEditor', {
      type: OperatingHours.TYPE,
      editor: OperatingHoursEditor
    });
    plg.addPlugin('ModelEditor', {
      type: WeeklyHours.TYPE,
      editor: WeeklyHoursEditor
    });
  }
};